import * as actions from 'store/actions/types';
import { updateObject } from '../utility';

const initialState = {
    accounts: [],
    account: {
        name: ''
    },
    showAccountMapping: false,
    snackBarOptions: {
        showSnackbar: false,
        message: '',
        variant: ''
    },
    selectedAccount: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actions.GET_ACCOUNTS:
            let accounts = action.payload;
            if (state.sortTable.length > 0) {
                let fieldName = state.sortTable.find((columnSort) => columnSort.active).fieldName;
                let direction = state.sortTable.find((columnSort) => columnSort.active).direction;
                accounts = accounts.sort((a, b) => {
                    var x = a[fieldName];
                    var y = b[fieldName];
                    if (fieldName !== 'name') {
                        x = a.address[fieldName];
                        y = b.address[fieldName];
                    }

                    if (fieldName === 'types') {
                        x = a.types
                            .map((type, tId) => {
                                return type.type;
                            })
                            .join(', ');
                        y = b.types
                            .map((type, tId) => {
                                return type.type;
                            })
                            .join(', ');
                    }

                    if (x !== undefined && x !== null) {
                        x = x.trim();
                    }

                    if (y !== undefined && y !== null) {
                        y = y.trim();
                    }

                    if (x > y) {
                        if (direction === 'asc') {
                            return 1;
                        }
                        return -1;
                    }
                    if (x < y) {
                        if (direction === 'asc') {
                            return -1;
                        }
                        return 1;
                    }
                    return 0;
                });
            }

            return updateObject(state, {
                accounts: accounts
            });

        case actions.GET_ACCOUNT:
            const accountName = action.payload.name;
            return updateObject(state, {
                account: action.payload,
                accountName
            });

        case actions.TOGGLE_ACCOUNT_MAPPING:
            return updateObject(state, { showAccountMapping: action.payload });

        case actions.TOGGLE_SNACKBAR:
            return updateObject(state, {
                snackBarOptions: { showSnackbar: action.payload }
            });

        case actions.GET_ACCOUNT_BY_ID:
            return updateObject(state, { selectedAccount: action.payload });

        default:
            return state;
    }
};
